import { reatomAsync, withDataAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { ProductSelectionParamKeysDto } from "definitions/product-storage";
import { API } from "src/api.ts";
import { withIsLoadingAtom } from "src/common/pipes";

const INITIAL_DATA: ProductSelectionParamKeysDto = { keys: [] };

export const getProductSelectionParamKeysRequest = reatomAsync(
  async (ctx, selectionId: number) => {
    return API.productSelectionApi
      .productSelectionControllerGetParamKeys(
        { selectionId },
        { signal: ctx.controller.signal },
      )
      .then((response) => response.data);
  },
  "getProductSelectionParamKeysRequest",
).pipe(withDataAtom(INITIAL_DATA), withAbort(), withIsLoadingAtom());
